<template>
    <div class="wrap">
        <div class="head">
            <div class="logo">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_1.png" class="logo_1">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_2.png" class="logo_2">
            </div>
            <div class="kv">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/kv.png">
            </div>
        </div>
        <div class="content">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/code.png">
            <div class="title title_1">
                <label>{{title_1}}</label>
            </div>
            <div class="title">
                <label>{{title_2}}</label>
            </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: "RepToken",
        data(){
            return{
                title_1:"关注微信公众号",
                title_2:"接受医生资质认证提醒消息",
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
    }
    .content{
        flex-grow: 1;
        overflow: scroll;
    }
    .head{
        width: 100%;
        /*height: 300px;*/
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .content .title{
        font-size: 18px;
        font-weight: bold;
    }
    .title_1{
        margin-top: 30px;
    }

</style>